import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { ViewManager } from '../../../core/view-manager';
import ModalListPicker from '../../../components/Modals/ModalListPicker';
import moment from 'moment';
import { toast } from 'react-toastify';



export default function IC_customer_offer({ data, entity = null, setDataKeyValue }) {
    const [showModal, setShowModal] = useState(false);
    const [customer, setCustomer] = useState(null)
    function openModal() {
        setShowModal(true);
    }
    function closeModal() {
        setShowModal(false);
    }


    async function getLanguages() {
        var res = await DataManager.getItem('languages', data.idCustomer.language?.id);
        if (res.success === 1) {
            setDataKeyValue('idLanguages', res.body[0]);
        }
    }
    async function getPaymentCondition() {
        var res = await DataManager.getItem('payment_condition', data.idCustomer.idPaymentCondition?.id);
        if (res.success === 1) {
            setDataKeyValue('idPaymentCondition', res.body[0]);
        }
    }
    async function getIncoterms() {
        var res = await DataManager.getItem('incoterms', data.idCustomer.idIncoterms?.id);
        if (res.success === 1) {
            setDataKeyValue('idIncoterms', res.body[0]);
        }
    }
    async function getAreaGeografica() {
        var res = await DataManager.getItem('area_geografica', data.idCustomer.idAreaGeografica?.id);
        if (res.success === 1) {
            setDataKeyValue('idAreaGeografica', res.body[0]);
        }
    }
    async function getVatCondition() {
        var res = await DataManager.getItem('vat_condition', data.idCustomer.idVatCondition?.id);
        if (res.success === 1) {
            setDataKeyValue('idVatCondition', res.body[0]);
        }
    }
    async function getCountryGroup() {
        var res = await DataManager.getItem('country_group', data.idCustomer.idCountryGroup?.id);
        if (res.success === 1) {
            setDataKeyValue('idCountryGroup', res.body[0]);
        }
    }
    async function getCountryGroup2() {
        var res = await DataManager.getItem('country_group_2', data.idCustomer.idCountryGroup2?.id);
        if (res.success === 1) {
            setDataKeyValue('idCountryGroup2', res.body[0]);
        }
    }
    async function getCustomer(id) {
        var res = await DataManager.getItem('customer', id);
        if (res.success === 1) {
            return res.body[0]
        } else {
            toast.error("Cliente non trovato", { theme: 'colored' })
        }
    }
    async function getWarehouse() {
        let constraints = [
            { fieldName: "no_mrp", type: "value", value: 0 },
            { fieldName: "internal", type: "value", value: 1 }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItemsSimple('warehouse', 1, 10, sorting, '', [], constraints);
        if (res.success === 1) {
            setDataKeyValue('idWarehouseOutlet', res.body[0]);
        }
    }




    useEffect(() => {
        if (data.idCustomer !== "") {
            setDataKeyValue('customer', getCustomer(data.idCustomer.id))
        }
    }, [data.idCustomer])









    useEffect(() => {
        console.warn(data);
        if (data.offerDate === null || data.offerDate === '') {
            var t = moment().format("YYYY-MM-DD")
            setDataKeyValue('offerDate', t)
        }
        if (data.idWarehouseOutlet === "") {
            getWarehouse()
        }
        if (data.idCustomer && data.idCustomer !== '' && data.idCustomer !== null) {
            localStorage.setItem('idCustomer', data.idCustomer.id)
            if (data.discount1 === "0") {
                if (data.discount1 !== data.idCustomer.discount1) {
                    setDataKeyValue('discount1', data.idCustomer.discount1)
                }
            }
            if (data.discount2 === "0") {
                if (data.discount2 !== data.idCustomer.discount2) {
                    setDataKeyValue('discount2', data.idCustomer.discount2)
                }
            }
            if (data.discount3 === "0") {
                if (data.discount3 !== data.idCustomer.discount3) {
                    setDataKeyValue('discount3', data.idCustomer.discount3)
                }
            }
            if (data.discount4 === "0") {
                if (data.discount4 !== data.idCustomer.discount4) {
                    setDataKeyValue('discount4', data.idCustomer.discount4)
                }
            }
            if (data.discount5 === "0") {
                if (data.discount5 !== data.idCustomer.discount5) {
                    setDataKeyValue('discount5', data.idCustomer.discount5)
                }
            }
            if (data.documentType === "" && data.documentType !== data.idCustomer.documentType) {
                setDataKeyValue('documentType', data.idCustomer.documentType)
            }
            console.log(data.idLanguages === "", data.idCustomer.language)
            if (data.idLanguages === "" && data.idCustomer.language) {
                getLanguages();
            }
            if (data.idPaymentCondition === "" && data.idPaymentCondition !== data.idCustomer.idPaymentCondition) {
                getPaymentCondition()
            }
            if (data.idIncoterms === "" && data.idCustomer.idIncoterms) {
                getIncoterms()
            }
            if (data.address === "" && data.idCustomer.offices > 0) {
                const fetchOffices = async () => {
                    const customer = await getCustomer(data.idCustomer.id);

                    for (var i = 0; i < customer.offices.length; i++) {
                        var item = customer.offices[i];
                        console.log('ITEM', item)
                        if (item.isDeliveryDefault === 1) {
                            setDataKeyValue('address', item)
                        }
                    }

                }
                fetchOffices()
            }
            if (data.idCustomer && data.idCustomer.offices && data.idCustomer.offices.length > 0) {
                var arrayIdSede = []
                for (var i = 0; i < data.idCustomer.offices.length; i++) {
                    arrayIdSede.push(data.idCustomer.offices[i].id);
                }
                localStorage.setItem('idCustomerOffice', data.idCustomer.id);
            } else {
                localStorage.setItem('idCustomerOffice', data.idCustomer.id);

            }

        }
        if (data.idSalesAgent) {
            if (data.idSalesAgent.cataloghi && data.idSalesAgent.cataloghi.length > 0) {
                var arrayId = [];
                for (let i = 0; i < data.idSalesAgent.cataloghi.length; i++) {
                    arrayId.push(data.idSalesAgent.cataloghi[i].idCatalog.id)
                }
                console.log(arrayId.toString());
                localStorage.setItem('idSalesAgentCatalog', arrayId.toString())

            } else {
                localStorage.removeItem('idSalesAgentCatalog')
            }
        }
        if (data.address) {
            if (data.address?.internalNotes !== "") {
                if (data.notesInternal === "") {
                    if (data.notesInternal !== data.address?.internalNotes) {
                        setDataKeyValue('notesInternal', data.address.internalNotes)
                    }
                }
            }
        }
        if (data.rows && data.rows.length > 0) {
            var totaleAgente = data.rows.filter(item => item.idItemModel?.provvigioneAgente === 1).reduce((acc, cur) => acc + (parseFloat(cur.totalRow) * parseInt(cur.percentualeAgente) / 100), 0);
            var totalePrescrittore = data.rows.filter(item => item.idItemModel?.provvigionePrescrittore === 1).reduce((acc, cur) => acc + (parseFloat(cur.totalRow) * parseInt(cur.percentualePrescrittore) / 100), 0);
            if (data.provvigioneAgente !== parseFloat(totaleAgente).toFixed(2)) {
                setDataKeyValue('provvigioneAgente', parseFloat(totaleAgente).toFixed(2))
            }
            if (data.provvigionePrescrittore !== parseFloat(totalePrescrittore).toFixed(2)) {
                setDataKeyValue('provvigionePrescrittore', parseFloat(totalePrescrittore).toFixed(2))
            }
            var totale = data.rows.reduce((acc, cur) => acc + parseFloat(cur.totalRow), 0);
            totale = totale + parseFloat(data.costSpedizione) + parseFloat(data.totalIncasso);

            var totaleIva = data.rows.reduce((acc, item) => acc + ((parseFloat(item.totalIva))), 0);
            totaleIva = totaleIva + (data.totalSpedizione - data.costSpedizione) + (data.totalIncassoIva - data.totalIncasso);

            var totalImballo = data.rows.reduce((acc, cur) => {
                if (cur.idItemModel?.type.value === "60_CASSA_DI_LEGNO") {
                    if (acc === undefined) {
                        acc = 0;
                    }
                    return acc + cur.total
                }
            }, 0);
            if (totalImballo !== undefined) {
                if (data.totalImballo !== parseFloat(totalImballo).toFixed(2)) {
                    setDataKeyValue('totalImballo', parseFloat(totalImballo).toFixed(2))
                }
            } else if (totalImballo === undefined) {
                if (data.totalImballo !== "0.00") {
                    setDataKeyValue('totalImballo', "0.00")
                }
            }

            var costImballo = data.rows.reduce((acc, cur) => {
                if (cur.idItemModel?.type.value === "60_CASSA_DI_LEGNO") {
                    if (acc === undefined) {
                        acc = 0;
                    }
                    return acc + cur.totalRow
                }
            }, 0);
            if (costImballo !== undefined) {
                if (data.costImballo !== parseFloat(costImballo).toFixed(2)) {
                    setDataKeyValue('costImballo', parseFloat(costImballo).toFixed(2))
                }
            } else if (costImballo === undefined) {
                if (data.costImballo !== "0.00") {
                    setDataKeyValue('costImballo', "0.00")
                }
            }

            var deliveryDate = data.rows.filter(item => item.deliveryDate !== "").reduce((latest, offer) => new Date(offer.deliveryDate) > latest ? new Date(offer.deliveryDate) : latest, new Date(0));
            if (data.deliveryDate !== moment(deliveryDate).format('YYYY-MM-DD')) {
                setDataKeyValue('deliveryDate', moment(deliveryDate).format('YYYY-MM-DD'))
            }




            if (parseFloat(data.totalIva).toFixed(2) !== parseFloat(totaleIva).toFixed(2)) {
                setDataKeyValue('totalIva', parseFloat(totaleIva).toFixed(2));
            }

            if (parseFloat(data.totalImponibile).toFixed(2) !== parseFloat(totale).toFixed(2)) {
                setDataKeyValue('totalImponibile', parseFloat(totale).toFixed(2));
            }
            if (data.totalImponibile !== "" && data.abbuono !== "" && data.totalIncasso !== "" && data.totalImballo !== "" && data.totalSpedizione !== "") {
                const a = parseFloat(totale) + parseFloat(data.totalIncasso) + parseFloat(data.totalSpedizione);
                const f = parseFloat(totale) + parseFloat(totaleIva);
                const target = (data.totalIva === "" || data.totalIva === "0,00") ? a : f;
                console.log(totale, data.totalIncasso, data.totalSpedizione, data.abbuono)
                if (parseFloat(data.totalPrice).toFixed(2) !== parseFloat(target).toFixed(2)) {
                    setDataKeyValue('totalPrice', parseFloat(target).toFixed(2));
                }
            }

        }
        if (data && data.rows) {
            const elementsWithPackaging = data.rows.filter(row => row.packaging === 1);
            const cassaName = data.rows.filter(row => row.idItemModel?.type.value === "60_CASSA_DI_LEGNO");
            const count1 = elementsWithPackaging.length;
            const countCassa = cassaName.length;
            if (countCassa < count1) {
                openModal();
            }
        }
        if (data.costSpedizione !== "0.00" && data.idVatCondition) {
            const costSp = parseFloat(data.costSpedizione || 0);
            const perc = parseFloat(data.idVatCondition?.percentage || 0);
            const t = costSp * (perc / 100);
            const t1 = t + costSp;
            if (parseFloat(data.totalSpedizione || 0).toFixed(2) !== parseFloat(t1).toFixed(2)) {
                setDataKeyValue('totalSpedizione', parseFloat(t1).toFixed(2))
            }
        } else {
            if (data.totalSpedizione !== "0.00") {
                setDataKeyValue('totalSpedizione', "0.00")
            }
        }
        if (data.idPaymentCondition !== "" && data.idVatCondition) {
            if (data.idPaymentCondition && data.idPaymentCondition.costInstallment !== null && data.idPaymentCondition.numberInstallments !== null) {
                if (data.costIncasso !== data.idPaymentCondition.costInstallment) {
                    setDataKeyValue('costIncasso', data.idPaymentCondition.costInstallment)
                }
                var t = parseFloat(data.idPaymentCondition.costInstallment) * parseInt(data.idPaymentCondition.numberInstallments);
                console.log(t, data.totalIncasso)
                if (data.totalIncasso !== t) {
                    setDataKeyValue('totalIncasso', t)
                }
                if (data.costIncasso !== "" && data.idVatCondition !== "") {
                    const a = parseFloat(data.idPaymentCondition.costInstallment) * parseFloat(data.idPaymentCondition.numberInstallments);
                    const b = a + (a * (data.idVatCondition?.percentage) / 100)
                    console.log(b, a, data.totalIncassoIva)
                    if (parseFloat(data.totalIncassoIva) !== parseFloat(b)) {
                        setDataKeyValue('totalIncassoIva', parseFloat(b))
                    }
                }
            }
        }
        if (data.idIncoterms) {
            var fieldSpedizione = document.getElementById("customer_offer_field_idSpedizione");
            if (data.idIncoterms.internalDelivery === 1) {
                fieldSpedizione.style.display = 'block';
                if (data.idSpedizione === "") {
                    if (data.idSpedizione !== data.idCustomer.idSpedizione) {
                        setDataKeyValue('idSpedizione', data.idCustomer.idSpedizione)
                    }
                }
            } else {
                fieldSpedizione.style.display = 'none';
            }

        }
    }, [data]);

    useEffect(() => {
        if (data.idSpedizione !== "" && data.idSpedizione && data.rows) {
            var totalRow = data.rows.reduce((acc, cur) => acc + parseFloat(cur.totalRow), 0);
            if (parseFloat(totalRow) > parseFloat(data.idSpedizione?.soglia)) {
                setDataKeyValue('costSpedizione', "0.00")
            } else {
                setDataKeyValue('costSpedizione', parseFloat(data.idSpedizione?.cost || 0).toFixed(2))
            }
        }
    }, [data.idSpedizione]);

    function selectRow(el) {
        var a = parseFloat(el.price) * (parseInt(el.idVatCondition.percentage) / 100)
        if (a === 0) {
            a = "0,00"
        }
        var cassaRow = {
            bindella: '',
            deliveryDate: '',
            deliveryTime: el.deliveryTime,
            discount1: '0',
            discount2: '0',
            discount3: '0',
            discount4: '0',
            discount5: '0',
            fulfilledQuantity: "0",
            grossWeight: el.grossWeight,
            idItemModel: el,
            idVatCondition: el.idVatCondition,
            internalNotes: "",
            measureUnit: el.unitMeasure,
            name: el.name,
            netWeight: el.netWeight,
            notes: el.notes,
            packages: el.packages,
            packaging: "0",
            price: el.price,
            quantity: "1",
            shippingDate: "",
            status: { value: '0_PENDING', label: '0_PENDING' },
            volume: el.volume,
            totalRow: el.price,
            totalIva: a,
            total: parseFloat(el.price) + parseFloat(el.price) * (parseInt(el.idVatCondition.percentage) / 100),
        }
        var temp = [...data.rows];
        temp.push(cassaRow);
        setDataKeyValue('rows', temp)
        closeModal();
    }


    useEffect(() => {
        if (window.location.pathname !== "/entity/customer_offer/edit") {
            if (data.certificatoOrigine !== data.idCustomer.certificatoOrigine) {
                setDataKeyValue('certificatoOrigine', data.idCustomer.certificatoOrigine)
            }
            if (data.codiciDoganaliInFatt !== data.idCustomer.codiciDoganaliInFatt) {
                setDataKeyValue('codiciDoganaliInFatt', data.idCustomer.codiciDoganaliInFatt)
            }

            if (data.notesOffer !== data.idCustomer.notesOffer) {
                setDataKeyValue('notesOffer', data.idCustomer.notesOffer)
            }

            if (data.notesInvoice !== data.idCustomer.notesInvoice) {
                setDataKeyValue('notesInvoice', data.idCustomer.notesInvoice)
            }

            if (data.idListino !== data.idCustomer.idListino) {
                setDataKeyValue('idListino', data.idCustomer.idListino)
            }
            if (data.idCountryStats !== data.idCustomer.idCountryStats) {
                setDataKeyValue('idCountryStats', data.idCustomer.idCountryStats)
            }
            if (data.idSalesAgent === "") {
                const fetchAgents = async () => {
                    if (data.idCustomer !== "") {
                        const customer = await getCustomer(data.idCustomer.id);
                        setDataKeyValue('idSalesAgent', customer.agenti[0])
                    }

                }
                fetchAgents()
            }
            if (data.idCapoArea?.id !== data.idSalesAgent !== "") {
                setDataKeyValue('idCapoArea', data.idSalesAgent.idCapoArea)
            }
            if (data.idLanguages?.id !== data.idCustomer.idLanguages) {
                getLanguages()
            }
            if (data.idAreaGeografica?.id !== data.idCustomer.idAreaGeografica) {
                getAreaGeografica()
            }
            if (data.idVatCondition?.id !== data.idCustomer.idVatCondition) {
                getVatCondition()
            }
            if (data.idIncoterms?.id !== data.idCustomer.idIncoterms) {
                getIncoterms()
            }
            if (data.idPaymentCondition?.id !== data.idCustomer.idPaymentCondition) {
                getPaymentCondition()
            }
            if (data.idCountryGroup?.id !== data.idCustomer.idCountryGroup) {
                getCountryGroup()
            }
            if (data.idCountryGroup2?.id !== data.idCustomer.idCountryGroup2) {
                getCountryGroup2()
            }
            if (data.italiaEstero !== data.idCustomer.italiaEstero) {
                setDataKeyValue('italiaEstero', data.idCustomer.italiaEstero)
            }
            if (data.address && data.idCustomer.offices > 0) {
                const fetchOffices = async () => {
                    const customer = await getCustomer(data.idCustomer.id);

                    for (var i = 0; i < customer.offices.length; i++) {
                        var item = customer.offices[i];
                        console.log('ITEM', item)
                        if (item.isDeliveryDefault === 1) {
                            setDataKeyValue('address', item)
                        }
                    }

                }
                fetchOffices()
            }
        }


    }, [data.idCustomer]);




    const [showModalFormularioOffer, setShowModalFormularioOffer] = useState(false);
    const [showModalFormularioInvoice, setShowModalFormularioInvoice] = useState(false);
    const [showModalFormularioCommercial, setShowModalFormularioCommercial] = useState(false);
    function openModalFormularioOffer() {
        setShowModalFormularioOffer(true);
    }
    function openModalFormularioInvoice() {
        setShowModalFormularioInvoice(true);
    }
    function openModalFormularioCommercial() {
        setShowModalFormularioCommercial(true);
    }

    function closeModalFormularioOffer() {
        setShowModalFormularioOffer(false);
    }
    function closeModalFormularioInvoice() {
        setShowModalFormularioInvoice(false);
    }
    function closeModalFormularioCommercial() {
        setShowModalFormularioCommercial(false);
    }
    var searchObjOffer = {
        'query': '',
        'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '0_ORDER' }]
    }
    var searchObjInvoice = {
        'query': '',
        'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '10_INVOICE' }]
    }
    var searchObjCommercial = {
        'query': '',
        'fields': [],
        'constraints': [{ fieldName: "type", type: "value", value: '30_DELIVERY' }]
    }
    function selectRowOffer(e) {
        var testo = data.notesOrder + e.description + ' ';
        if (data.notesOrder !== testo) {
            setDataKeyValue('notesOffer', testo);
            toast.success('Nota aggiunta con successo!')
        }
    }
    function selectRowInvoice(e) {
        var testo = data.notesInvoice + e.description + ' ';
        if (data.notesInvoice !== testo) {
            setDataKeyValue('notesInvoice', testo)
            toast.success('Nota aggiunta con successo!')
        }
    }
    function selectRowCommercial(e) {
        var testo = data.notesInternal + e.description + ' ';
        if (data.notesInternal !== testo) {
            setDataKeyValue('notesInternal', testo)
            toast.success('Nota aggiunta con successo!')
        }
    }

    useEffect(() => {


        console.log(ViewManager.getVisibleColumns(entity))




        if (entity === "customer_offer") {
            const elementIDOffer = document.querySelector('#customer_offer_field_notesOffer .field__text');
            const elementIDInvoice = document.querySelector('#customer_offer_field_notesInvoice .field__text');
            const elementIDCommercial = document.querySelector('#customer_offer_field_notesInternal .field__text');
            if (!elementIDOffer.querySelector('#btn_notesOffer')) {
                elementIDOffer.appendChild(genButtonOffer());
            }
            if (!elementIDInvoice.querySelector('#btn_notesInvoice')) {
                elementIDInvoice.appendChild(genButtonInvoice());
            }
            if (!elementIDCommercial.querySelector('#btn_notesInternal')) {
                elementIDCommercial.appendChild(genButtonCommercial());
            }
        }

        function genButtonOffer() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesOffer';
            a.addEventListener('click', (event) => { event.preventDefault(); openModalFormularioOffer(); })
            a.textContent = "Aggiungi note preventivo";
            return a;
        }
        function genButtonInvoice() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesInvoice';
            a.addEventListener('click', (event) => { event.preventDefault(); openModalFormularioInvoice(); })
            a.textContent = "Aggiungi note fattura";
            return a;
        }
        function genButtonCommercial() {
            let a = document.createElement('button');
            a.classList.add("btn", "btn-primary", "mt-2", "btn-sm");
            a.id = 'btn_notesInternal';
            a.addEventListener('click', (event) => { event.preventDefault(); openModalFormularioCommercial(); })
            a.textContent = "Aggiungi istruzioni per il trasportatore";
            return a;
        }
    }, []);



    return (
        <>

            {showModal ? <>
                <ModalListPicker entity={'gyv_item_model_cassa'} closeModal={closeModal} modalStatus={showModal} selectRow={selectRow} />
            </> : null}

            {data.idCustomer && data.idCustomer.notesInternal !== "" ?
                <Alert variant="warning" dismissible>
                    <Alert.Heading>Istruzioni a operatore</Alert.Heading>
                    <p style={{ whiteSpace: "pre-line" }}>
                        {data.idCustomer.notesInternal}
                    </p>
                </Alert>
                : <></>}



            {showModalFormularioOffer ? <ModalListPicker entity={'formulario'} closeModal={closeModalFormularioOffer} modalStatus={showModalFormularioOffer} selectRow={selectRowOffer} defaultSearchObj={searchObjOffer} /> : null}
            {showModalFormularioInvoice ? <ModalListPicker entity={'formulario'} closeModal={closeModalFormularioInvoice} modalStatus={showModalFormularioInvoice} selectRow={selectRowInvoice} defaultSearchObj={searchObjInvoice} /> : null}
            {showModalFormularioCommercial ? <ModalListPicker entity={'formulario'} closeModal={closeModalFormularioCommercial} modalStatus={showModalFormularioCommercial} selectRow={selectRowCommercial} defaultSearchObj={searchObjCommercial} /> : null}


        </>
    )
};
